import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/office/places/")({
  beforeLoad: async () => {
    throw redirect({
      to: "/office/places/active",
    });
  },
});
